import { useMaxWidth, useUISize } from 'app/utils/web-helpers';
import { useWindowDimensions } from 'react-native';

export function useDeviceWidth(): number {
  const window = useWindowDimensions();
  const maxWidth = useMaxWidth();
  const { isSmallUI } = useUISize();
  const deviceWidth = isSmallUI ? Math.min(window.height, window.width) : Math.min(maxWidth as number, window.width);
  return deviceWidth;
}

export function useDeviceHeight(): number {
  const window = useWindowDimensions();
  const { isSmallUI } = useUISize();
  const deviceHeight = isSmallUI ? Math.max(window.height, window.width) : window.height;
  return deviceHeight;
}
